import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import refreshIcon from './../../Images/refreshIcon.svg';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import StatusCard from '../StatusCard';
import ResolvedStatus from '../ResolvedStatus';
import HelpText from '../HelpText';
import ContactButtons from '../ContactButtons';
import { reportDWH }  from './../../ZoneFaultSlice';

function StatusPage(props) {


    useEffect(() => {
        props.reportDWH({status: 'Completed',messageText: 'Regional Fault Status Page Displayed'});
     }, [props.zoneFaultStatus]);

  let selectedProduct = props.selectedProduct;
  let zoneFaultStatus = props.zoneFaultStatus;

  var productAddress = selectedProduct?.address ?? zoneFaultStatus?.address;

  let cmsStatusList = props.cmsStatusList;
  let currentStatus = cmsStatusList.find(item => item.statusName === zoneFaultStatus?.status);

  let subTitle = currentStatus?.subTitle;
  let text = currentStatus?.text;
  let cardTitle = currentStatus?.cardTitle;

  const isDisplayWhatsAppIcon = true;
  let time = zoneFaultStatus?.endTime;
  let endDate = zoneFaultStatus?.endDate;

  let cmsTextData = props.cmsTextData;
  let faultSendNotificationText = cmsTextData.faultSendNotificationText;
  let faultSendNotificationTextError = cmsTextData.faultSendNotificationTextError;
  let isDelay = zoneFaultStatus?.status === 'issueDelayed' || zoneFaultStatus?.status === 'plannedWorkDelayed';
  let jobResolved = zoneFaultStatus?.status === 'plannedJobFinished' || zoneFaultStatus?.status === 'networkNormal';
  let issueResolved = zoneFaultStatus?.status === 'issueResolved';
  let issueOrjobResolved = jobResolved || issueResolved;

  return (
    <div className='status-page'>
      <div className='title'>{productAddress}</div>
      <div className='sub-title'>{subTitle}</div>
      {text && <div className='text' dangerouslySetInnerHTML={{ __html: text }} />}
      <StatusCard cardTitle={cardTitle} faultSendNotificationText={faultSendNotificationText} faultSendNotificationTextError={faultSendNotificationTextError} time={time} endDate={endDate} statusTimeText={zoneFaultStatus?.statusTimeText} jobResolved={jobResolved} issueResolved={issueResolved} />
      <HelpText status={currentStatus?.statusName} isDelay={isDelay} cmsTextData={cmsTextData} issueOrjobResolved={issueOrjobResolved} />
      {/* {isDelay && (
       <ContactButtons />
      )} */}
       {issueOrjobResolved && (
        <ResolvedStatus text={cmsTextData?.bottomText} urlButtonText={cmsTextData?.urlButtonText} urlButton={cmsTextData?.urlButton} />
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    selectedProduct : state.zoneFaultBlock.selectedProduct,
    zoneFaultStatus : state.zoneFaultBlock.zoneFaultStatus,
    isMagicLink : state.zoneFaultBlock.isMagicLink,
  };
};

const mapDispatchToProps = {
  reportDWH,
};

export default connect(mapStateToProps, mapDispatchToProps)(StatusPage);
